import { Categoria, VacanteFiltros } from '../models/vacante.model';
import { slugify } from './slugify';

export interface PaisSlug {
  code: string;
  slug: string;
}

/** Construye el path amigable /vacantes[/categoria/:slug][/pais/:slug][/ciudad/:slug]. */
export function construirPathVacantes(slugs: {
  categoriaSlug?: string;
  paisSlug?: string;
  ciudadSlug?: string;
}): string[] {
  const path = ['/vacantes'];
  if (slugs.categoriaSlug) path.push('categoria', slugs.categoriaSlug);
  if (slugs.paisSlug) path.push('pais', slugs.paisSlug);
  if (slugs.ciudadSlug) path.push('ciudad', slugs.ciudadSlug);
  return path;
}

// Solo estas claves viajan como query params — categoría, país y ciudad viven
// en el path (ver construirPathVacantes).
const CLAVES_QUERY_PARAMS: (keyof VacanteFiltros)[] = [
  'q',
  'tipoContrato',
  'seniority',
  'salarioMin',
  'salarioMax',
  'modalidad',
  'sortBy',
  'page',
];

export function construirQueryParamsVacantes(filtros: Partial<VacanteFiltros>): Record<string, string> {
  const queryParams: Record<string, string> = {};
  CLAVES_QUERY_PARAMS.forEach((key) => {
    const value = filtros[key];
    if (value !== undefined && value !== null && value !== '' && value !== 0) {
      queryParams[key] = String(value);
    }
  });
  return queryParams;
}

/** Resuelve un VacanteFiltros completo (con sector/pais/ciudad en texto) a la ruta amigable + query params. */
export function resolverFiltrosANavegacion(
  filtros: VacanteFiltros,
  categorias: Categoria[],
  paises: PaisSlug[]
): { path: string[]; queryParams: Record<string, string> } {
  const categoria = filtros.sector ? categorias.find((c) => c.id === filtros.sector) : undefined;
  const pais = filtros.pais ? paises.find((p) => p.code === filtros.pais) : undefined;

  const path = construirPathVacantes({
    categoriaSlug: categoria?.slug,
    paisSlug: pais?.slug,
    ciudadSlug: filtros.ciudad ? slugify(filtros.ciudad) : undefined,
  });

  return { path, queryParams: construirQueryParamsVacantes({ ...filtros, page: 0 }) };
}
